/* eslint-disable import/no-cycle */
import ImageCockpitWidget from '../components/cockpit/shared/widgets/ImageCockpitWidget';
import DataTableWidget from '../components/cockpit/shared/widgets/DataTableWidget';
import TimeseriesCockpitWidget from '../components/cockpit/shared/widgets/TimeseriesCockpitWidget';
import EventDurationCockpitWidget from '../components/cockpit/shared/widgets/EventDurationCockpitWidget';
import KpiChartWidget from '../components/cockpit/shared/widgets/KpiChartWidget';
import KpiLossCockpitWidget from '../components/cockpit/shared/widgets/KpiLossCockpitWidget';
import KpiPerOrderCockpitWidget from '../components/cockpit/shared/widgets/KpiPerOrderCockpitWidget';
import InterruptionAnalysisWidget from '../components/cockpit/shared/widgets/InterruptionAnalysisWidget';
import TagInterruptionAnalysisWidget from '../components/cockpit/shared/widgets/TagInterruptionAnalysisWidget';
import MultipleTimeseriesCockpitWidget from '../components/cockpit/shared/widgets/MultipleTimeseriesCockpitWidget';

// register all available cockpit widgets here so they can be found by the widget configuration.
// NOTE: widget components need to respond to 'identifier' and 'defaultLayout'

export const CockpitWidgetRegistry = [
  ImageCockpitWidget,
  DataTableWidget,
  TimeseriesCockpitWidget,
  MultipleTimeseriesCockpitWidget,
  EventDurationCockpitWidget,
  KpiChartWidget,
  KpiLossCockpitWidget,
  KpiPerOrderCockpitWidget,
  InterruptionAnalysisWidget,
  TagInterruptionAnalysisWidget,
];
